import React, { memo } from 'react'
import { ValidatorForm } from 'react-material-ui-form-validator'
import TextInput from './TextInput'
import { FormConfiguration } from '../configuration'
import Selectors from './Selectors'
import CheckBoxes from './CheckBoxes'
import Button from '../Button'
import { useAppSelector } from '../app/hooks/reduxHooks'
import { useMediaQuery } from '@material-ui/core'
import styles from './Form.module.sass'

function Form() {
    const firstCheckBoxChecked = useAppSelector(state => state.form.firstCheckBox)
    const isMobile = useMediaQuery('(max-width: 760px)')
    const textAreaLabel = isMobile ? 'Il tuo messaggio' : 'Messaggio'
    const textAreaPlaceHolder = isMobile ? 'Inserisci il tuo messaggio' : 'Il tuo messaggio'    
    const handleSubmit = () => {
        if (window.dataLayer) {
            window.dataLayer.push({
                'event': 'lp_form_submit',
                'section': 'Osmos'
            });
        }
        console.log('Form inviato');
    }
    return (
        <div seconds={3} className={`${styles.root} scroll-fadein-late`}>
            <ValidatorForm noValidate onSubmit={handleSubmit} className={styles.root} >
                <span className={styles.doubleRow} >
                    <TextInput
                        validate
                        placeholder='Nome'
                        validationType='isText'
                        validationMessage='Si prega di fornire un nome corretto'
                        name='nome'
                        label='Nome'
                    />
                    <TextInput
                        validate
                        placeholder='Cognome'
                        validationType='isText'
                        validationMessage='Si prega di fornire un cognome corretto'
                        name='cognome'
                        label='Cognome'
                    />
                </span>
                <span className={styles.doubleRow} >
                    <TextInput
                        name='professione'
                        label='Professione'
                        placeholder='Professione'
                    />
                    <TextInput
                        validate
                        validationType='isEmail'
                        validationMessage='Si prega di fornire un email corretto'
                        name='email'
                        label='Email'
                        placeholder='Email'
                    />
                </span>
                <Selectors />
                <span className={styles.textArea} >
                    <TextInput
                        name='messagio'
                        label={textAreaLabel}
                        placeholder={textAreaPlaceHolder}
                        multiLine
                        fullWidth
                    />
                </span>
                <p className={styles.campi} >* Campi obbligatori</p>
                <p className={styles.p} >Ho letto e compreso l'
                    <a
                        className={styles.a}
                        href={FormConfiguration.infoSulPrivacy} >
                        informativa sulla privacy
                    </a>
                </p>
                <CheckBoxes />
                <div className={styles.submitBox}>
                    <Button 
                        disabled={!firstCheckBoxChecked} 
                        label={"Ricevi informazioni"} 
                        type='submit' 
                        className={styles.submitBtn} 
                    />
                </div>
            </ValidatorForm>
        </div>
    )
}

export default memo(Form)